import React from 'react';
import PropTypes from 'prop-types';

import {
    Spacer,
    Text,
    Flex,
} from '@zillow/constellation';

import PostPublishUpsell from 'app/shared/components/PostPublishUpsell';
import PaidInclusionConstants from 'app/shared/constants/PaidInclusionConstants';
import { StyledContainer, StyledIcon } from './StyledComponents';

const propTypes = {
    isInPaidMarket: PropTypes.bool.isRequired,
    onEnableApplications: PropTypes.func.isRequired,
    onEnableLeases: PropTypes.func.isRequired,
    upsellType: PropTypes.oneOf(['None', 'Applications']),
};

const defaultProps = {
    upsellType: 'None',
};

const PostActivationModal = ({
    activeProductType,
    expirationDate,
    isInPaidMarket,
    isListingFree,
    onEnableApplications,
    onEnableLeases,
    price,
    upsellType,
}) => {
    const rememberToDeactivateText = `Your listing is on its way to Zillow, Trulia and HotPads.
        Remember to deactivate your listing once you find a renter.`;

    const renderIsPaidMarketContent = () => {
        const paidWithFlatFee = activeProductType === PaidInclusionConstants.PRODUCT_TYPE[2];
        let text = `Your listing will renew each week unless you deactivate it. Your card will be charged
            ${price} each time. You’ll be notified 48 hours before each renewal.`;
        if (isListingFree) {
            text = `Your listing will remain active for 4 weeks or until you deactivate it.
                You can republish it if you need more time to find your next renter.`;
        } else if (paidWithFlatFee) {
            text = rememberToDeactivateText;
        }
        return (
            <div data-test="paid-market-content">
                <Spacer paddingBottom="xs">
                    <Text data-test="activation-text">
                        {text}
                    </Text>
                </Spacer>
                <Spacer data-test="date-row">
                    <Text fontType="bodyHeading">
                        {`${isListingFree || paidWithFlatFee ? 'Expires' : 'Renews'}: ${expirationDate}`}
                    </Text>
                </Spacer>
            </div>
        );
    };

    const renderNotPaidMarketContent = () => {
        const noUpsell = `Renters on Zillow, Trulia and HotPads can now contact you and submit rental
            applications directly from your listing.`;
        return (
            <Spacer data-test="not-paid-market-content" paddingBottom="xs">
                <Text data-test="activation-text">
                    {upsellType === 'Applications' ? rememberToDeactivateText : noUpsell}
                </Text>
            </Spacer>
        );
    };

    return (
        <StyledContainer>
            <Spacer marginBottom="md">
                <Flex display="flex" justifyContent="center">
                    <StyledIcon size="lg" />
                </Flex>
                <Text fontType="h4">Your listing has been published!</Text>
                <Spacer marginY="sm">
                    {isInPaidMarket ? renderIsPaidMarketContent() : renderNotPaidMarketContent()}
                </Spacer>
            </Spacer>
            <PostPublishUpsell
                upsellType={upsellType}
                onEnableApplications={onEnableApplications}
                onEnableLeases={onEnableLeases}
            />
        </StyledContainer>
    );
};

PostActivationModal.propTypes = propTypes;
PostActivationModal.defaultProps = defaultProps;

export { PostActivationModal };
export default PostActivationModal;
